<div class="locations-dropdown d-inline-block" ngbDropdown>
  <button class="btn btn-outline-primary mr-2" id="dropdownLocations" ngbDropdownToggle>
      <span [ngSwitch]="location">
          <i class="fa-solid fa-location-dot"></i>
          <span *ngIf="location === ''">
            <span translate>All</span>
          </span>
          <span *ngIf="location !== ''" [innerText]="location">
          </span>
        </span>
    <span class="caret"></span>
  </button>
  <div aria-labelledby="dropdownLocations" ngbDropdownMenu>
    <div class="search">
      <input [(ngModel)]="searchedLocation" [placeholder]="('Search location' | translate)+'...'"
             class="form-control"
             type="search">
    </div>
    <div class="dropdown-divider"></div>
    <button (click)="onLocationChange('')" ngbDropdownItem>
      <div class="d-flex justify-content-between align-items-center">
        <span translate>All</span>
<!--        <span [innerText]="machineCount" class="badge badge-pill badge-primary"></span>-->
      </div>
    </button>
    <div class="dropdown-divider"></div>
    <h6 class="dropdown-header" translate>Locations</h6>
    <div class="dropdown-scrollarea">
      <div *ngFor="let location of getFilteredLocations() | keyvalue">
        <button (click)="onLocationChange(location.key)" [ngbTooltip]="location.key"
                ngbDropdownItem>
          <div class="d-flex justify-content-between align-items-center">
            <ngb-highlight class="dropdown-tooltip-hover-dashboard-location" [result]="location.key" [term]="searchedLocation" [title]="location.key"></ngb-highlight>
            <span [innerText]="location.value" class="badge badge-pill badge-primary"></span>
          </div>
        </button>
      </div>

    </div>
  </div>
</div>
